import dashboard from './en.json';

const DataTranslate = { dashboard };
export default DataTranslate;
